export default __webpack_public_path__ + "static/media/blog1_image.527f1432.png";